import { CardActionArea } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'

interface Props {
  to?: string
  title: string
  body: JSX.Element
}
export default function PrimaryCard({ to = '/', title, body }: Props) {
  return (
    <Card sx={{ maxWidth: 1000, height: '100%' }}>
      <Link to={to}>
        <CardActionArea>
          <CardContent>
            <Typography gutterBottom variant="h5" component="h4">
              {title}
            </Typography>
            <Typography variant="body2" component="div">
              {body}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}
